export default __webpack_public_path__ + "static/GregoryMcDonald-5ecdff1ab14b88d3eb39211398184a5a.jpg";